import { BalanceTile } from "./tiles/BalanceTile";
import { PointsTile } from "./tiles/PointsTile";
import { LastTransactionsTile } from "./tiles/LastTransactionsTile";
import { FeaturedPerksTile } from "./tiles/FeaturedPerksTile";
import { OffersTile } from "./tiles/OffersTile";

export const CardholderHomePage = () => {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
      <BalanceTile className="md:col-span-2" />
      <PointsTile />
      <LastTransactionsTile />
      <FeaturedPerksTile />
      <OffersTile />
    </div>
  );
};
